import SupplierList from './SupplierList';

export default SupplierList;